import * as constants from '../constants';

export const requestChangeLanguage = (language) => ({type: constants.SETTINGS_CHANGE_LANGUAGE, payload: {language}});
